import {useConfiguration} from '../../../hooks/configuration';
import {getMsFromS} from '../../../utils/datetime';
import {useGetEventSummaryQuery} from '../api/eventSummaryApi';

export const useEventSummaryPolling = () => {
  const refresh = useConfiguration('auto-refresh', 'event_summary_autorefresh_rate');
  const pollingInterval = refresh?.value ? getMsFromS(+refresh.value) : undefined;

  useGetEventSummaryQuery(undefined, {
    pollingInterval: pollingInterval ?? undefined,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
};
